import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import formatCurrency from '../../utility/formatCurrency';
import convertTimestampToDate from '../../utility/convertTimestampToDate';

const CashflowRow = ({ title, cashflowType, cashflowStatement, currency }) => {
    return (
        <Tr>
                    <Th>{title}</Th>
                    {cashflowStatement.map((statement, index) => (
                        <Td key={index}>
                            {(isNaN(statement[cashflowType]) || statement[cashflowType] == null) ? (
                                '----'
                            ) : (
                                formatCurrency(statement[cashflowType], currency)
                            )}
                        </Td>
                    ))}
                </Tr>
    );
}

const CashflowTable = ({ cashflowStatement, currency }) => {

    return (
        <Table variant="simple">
            <Thead>
                <Tr>
                    <Th></Th>
                    {cashflowStatement.map((statement, index) => (
                        <Th key={index}>{statement.date}</Th>
                    ))}
                </Tr>
            </Thead>
            <Tbody>
                <CashflowRow title='Free Cash Flow' cashflowType='freeCashFlow' cashflowStatement={cashflowStatement} currency={currency}/>
                <CashflowRow title='Operating Cash Flow' cashflowType='operating' cashflowStatement={cashflowStatement} currency={currency}/>
                <CashflowRow title='Investing Cash Flow' cashflowType='investing' cashflowStatement={cashflowStatement} currency={currency}/>
                <CashflowRow title='Financing Cash Flow' cashflowType='financing' cashflowStatement={cashflowStatement} currency={currency}/>
            </Tbody>
        </Table>
    );
}

export default CashflowTable;